import { createContext } from 'react'

export const MixPanelContext = createContext(null)
export const ProductPageContext = createContext(null)
